import { useEffect, useState } from "react";

export function useRafNow(enabled: boolean) {
    const [now, setNow] = useState(() => performance.now());

    useEffect(() => {
        if (!enabled) return;
        let raf = 0;
        const tick = () => {
            setNow(performance.now());
            raf = requestAnimationFrame(tick);
        };
        raf = requestAnimationFrame(tick);
        return () => cancelAnimationFrame(raf);
    }, [enabled]);

    return now;
}
